<ng-container *ngIf="!(BS.TouchQuery | async)">
    <div id="tui-image-editor" style="height: 100%">
        <canvas>
        </canvas>
    </div>
    <button app-round-button (click)="Save$.next()" class="save-button" [IsLoading]="ls.IsLoading$ | async"><fa-icon icon="save"></fa-icon></button>
</ng-container>
<app-mobile-image-editor *ngIf="BS.TouchQuery | async" [File]="File$ | async" [Version]="Version$ | async"></app-mobile-image-editor>

